/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Mb } from './Mb';

class EnterprisePracticeMaterials extends Mb {
    constructor() {
        super();
        this.baseUrl += '/enterprisePracticeMaterials';
    }

    data({ enterpriseName, fileName, verticalGroupingName, status, insertTime, currentPage, pageSize } = {}) {
        let insertBeginTime = null;
        let insertEndTime = null;
        if (insertTime != null && insertTime.length === 2) {
            [insertBeginTime, insertEndTime] = insertTime;
        }
        return super.get('/data', {
            enterpriseName,
            fileName,
            verticalGroupingName,
            status,
            insertBeginTime,
            insertEndTime,
            currentPage,
            pageSize,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }

    relatedGrouping({ ids, verticalGroupingId }) {
        return super.post('/relatedGrouping', { ids, verticalGroupingId });
    }

    cancelGrouping({ id }) {
        return super.post('/cancelGrouping', { id });
    }
}

export default new EnterprisePracticeMaterials();
export { EnterprisePracticeMaterials };
